import { key_exists } from './key_exists'

export const input_transformation_dropdown = (device_data: any) => {
    let drop_down_value = null
    const path_frame_base = 'config.base.vehicle_detection.scanner.trajectory_classification.classifier'
    const path_frame_diff = 'config.diff.vehicle_detection.scanner.trajectory_classification.classifier'

    if (key_exists(device_data, path_frame_diff))
        drop_down_value = device_data.config.diff.vehicle_detection.scanner.trajectory_classification.classifier
    if (drop_down_value !== null) {
        //console.log('loaded drop_down_value from diff config: ', drop_down_value)
        return { base: 'false', value: drop_down_value }
    }
    if (key_exists(device_data, path_frame_base))
        drop_down_value = device_data.config.base.vehicle_detection.scanner.trajectory_classification.classifier
    if (drop_down_value !== null) {
        //console.log('loaded drop_down_value from base config: ', drop_down_value)
        return { base: 'true', value: drop_down_value }
    }
    //console.log('could not load drop_down_value from config')
    return { base: 'null', value: 'null' }
}
